/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



/*****************
 ** WEBPACK FOOTER
 ** ./~/recompose/~/lodash/_realNames.js
 ** module id = 410
 ** module chunks = 0
 **/